<template>
    <!-- 拍卖会 -->
    <div class="index page">
        <panel
            ref="panel"
            :wapTitle="''"
            :appLink="'/2/8/0'"
            :spreadID="'0'"
            :showNav="false"
            :isShowNav="false"
            @gotoApp="gotoApp"
            :isApp="false"
        ></panel>
        <!-- 搜索头部 -->
        <div class="search_top">
            <form action="/" style="display: flex;align-items: center;background: #fff;">
            <img @click="cancel" class="search_back" src="../../assets/img/Frame585_new@2x.png" alt="">
            <van-search
                v-model="value"
                show-action
                shape="round"
                background="#FFFFFF"
                placeholder="书画"
                @input="pnt"
                @search="search"
                @focus="focusValue"
                @blur="blurValue"
            >
            <template #action>
                    <div @click="search">搜索</div>
                </template>
            </van-search>
            </form>
        </div>
        <div class="wordBox"  v-if="focusFlag&&value&&wordList.length>0">
            <template  v-for="(item, index) in wordList"  >
                <div class="sourceWord" :key="index+'sourceWord'" @click="jumpSearch(item)" >
                    <van-icon name="search" />
                    <span  v-html="item.source_wordShow"></span>
                </div>
            </template>
        </div>
        <!-- tab页 -->
        <div class="search_tabsmm">
            <!-- search -->
            <div class="tabItem" data-index="0" @click="scFun('35','2','1'),gotoSearch('search')">
                综合
            </div>
            <div class="tabItem" data-index="1" @click="scFun('35','2','2'),gotoSearch('paipin')">
                拍品
            </div>
            <div class="tabItem active" data-index="2">拍卖会</div>
            <div class="tabItem" data-index="3" @click="scFun('35','2','4'),gotoSearch('company')">
                拍卖公司
            </div>
            <div class="tabItem" data-index="4" @click="scFun('35','2','5'),gotoSearch('market')">
                市场报告
            </div>
            <div class="tabItem" data-index="5" @click="scFun('35','2','6'),gotoSearch('infor')">
                资讯
            </div>
        </div>
        <!-- 在搜索选项有数据的时候显示的页面 -->
        <histor
            linkName="paiacution"
            v-if="hiss"
            :nunber="param.type"
            :water="showWater"
        ></histor>
        <!-- 在搜索没有显示的时候 -->
        <!-- 拍卖中 -->
        <div class="auctionbox" v-if="!hiss&&!(focusFlag&&value&&wordList.length>0)">
            <div class="auction">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="——— 我是有底线的 ———"
                    @load="onLoad"
                >
                    <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
                    <!-- 拍卖会列表 -->
                    <div
                        class="auction-item"
                        v-for="(item, index) in tionList"
                        :key="index"
                    >
                        <div class="item-top" @click="sessJump(item,index)">
                            <div :class="'item-icon' + item.status"></div>
                            <div class="txt">{{ item.name }}<span></span></div>
                        </div>
                        <div class="item-brief" @click="sessJump(item,index)">
                            <div
                                class="brief"
                                v-for="(a, b) in item.extraInfo"
                                :key="b"
                            >
                                <div class="brief-icon">
                                    <img
                                        v-if="b == 0"
                                        src="@/assets/img/icon_list_other_light@2x.png"
                                    />
                                    <img
                                        v-if="b == 1"
                                        src="@/assets/img/icon_list_time_light@2x.png"
                                    />
                                </div>
                                <span>{{ a.text }}</span>
                                <i v-if="b==1 && item.OnlineAuction == 1">网络拍卖</i>
                            </div>
                        </div>
                        <div class="speSwiper">
                            <div class="speSwiperContainer">
                                <ul class="speSwiperWrapper" :style="{width:5.15*item.specialsList.length+'rem'}">
                                    <li
                                        @click="zhuanjUMP(m,i)"
                                        class="swiper-slide"
                                        v-for="(m, i) in item.specialsList"
                                        :key="i"
                                    >
                                        <div class="imgCenter">
                                            <!-- <img src="@/assets/img/avator.jpeg" alt="" />coverPic -->
                                            <img :src="m.coverPic" alt="" />
                                            <span
                                                class="HiPic"
                                                v-if="m.isHD > 0"
                                            ></span>
                                            <span class="live" v-if="m.live_info.have_live == 1 && m.live_info.live_status == 2"><img src="../../assets/img/live.gif" alt=""></span>
                                            <span class="liveReview" v-else-if="m.live_info.have_live == 1 && m.live_info.live_status == 0 || m.live_info.live_status == 1">即将开播</span>
                                            <span class="liveReview" v-else-if="m.live_info.have_live == 1 && m.live_info.live_status == 4 && m.live_info.have_review == 1">直播回放</span>
                                        </div>
                                        <h3 class="name">{{ m.name }}</h3>
                                        <div class="tags" v-if="m.live_info.label_list.length">
                                            <template v-for="(label, k) in m.live_info
                                                    .label_list">
                                                <span :key="k" v-if="label.name=='视频直播'" class="tag videoLive"></span>
                                                <span :key="k" v-if="label.name == '同步拍'" class="tag tbPai"></span>
                                                <span :key="k" v-if="label.name == '限时拍'" class="tag xsPai">限时拍</span>
                                                <span :key="k" v-if="label.name == '图文直播'" class="tag imgLive"></span>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>

            <!-- 底部 -->
            <EmptyPage v-if="noMore"></EmptyPage>
        </div>
        <share :nunber="param.type"></share>
        <DownLoadApp ref="downloadPop"></DownLoadApp>
        <watermark v-if="showWater"></watermark>
    </div>
</template>

<script>
import histor from "./component/histor.vue";
import { pmwill,searchWord } from "@/api/auction";
import share from "./component/metaComponent.vue";
import panel from "@/views/preview/component/panel";
import DownLoadApp from "@/components/common/downloadApp";
import watermark from "@/components/common/watermark";
import EmptyPage from "@/components/empty/emptyPage";
import {
    scMdFunc
} from "@/assets/js/scData";
export default {
    data() {
        return {
            showWater: false,
            waterLink: "",
            value: "", //搜索内容
            appLink:'/2/8/0',
            hiss: true,
            param: {
                type: 1,
                page: 1,
                keyword: "",
            },
            tionList: [], //拍卖会列表
            noMore: false, //我是有底线的
            loading: false,
            finished: false,
            focusFlag:false,
            wordList:[]
        };
    },
    watch: {},
    created() {
        if (this.$route.query.from) {
            this.showWater = true;
            this.waterLink = "&from="+this.$route.query.from;
        }
        if (this.$route.query.searchValue) {
            this.hiss = false;
            this.value = decodeURIComponent(this.$route.query.searchValue);
            this.getpmwill();
        }
    },
    methods: {
        brightKeyword(e){
            let keyword=e;
            let val = this.value;
            keyword=keyword.trim();
            if(keyword&keyword.length>0){
                if(keyword == val){
                    return '<span>'+val+'</span>'
                }
                keyword = keyword.replaceAll("","|");
                let reg = new RegExp(keyword,"ig")
                return val.replace(reg,(match) =>{
                    return  '<span>'+match+'</span>' 
                })
            }
        },
        scFun(p='',m='',b='',dataEle) {//新单击埋点
                scMdFunc('allClick',  {
                    cur_page: p,
                    cur_moudle: p+'-'+m,
                    cur_button: p+'-'+m+'-'+b,
                    ...dataEle
                })
        },
        focusValue(){
            this.focusFlag=true;
            scMdFunc('allClick', {
                cur_page: '35',
                cur_moudle: '35-1',
                cur_button: '35-1-1',
            })
            searchWord({
                    keyword:this.value,
                    type:2
                }).then((res) => {
                        if (res.code == 0) {
                            this.wordList = res.data.list
                            this.wordList = this.wordList.map((item) => {
                                let replaceReg = new RegExp(this.value, 'g');
                                let replaceContent = '<span style="color:#18BD6F">' + this.value + '</span>';
                                if (item.source_word.includes(this.value)) {
                                item.source_wordShow = item.source_word.replace( replaceReg,replaceContent);
                                }else{
                                    item.source_wordShow = item.source_word
                                }
                                return item;
                            });
                        }
               })
        },
        blurValue(){
            let that = this;
            setTimeout(()=>{
                that.focusFlag=false;
            },500)
           
        },
        jumpSearch(e){
            this.value=e.source_word;
            this.gotoSearch('paiacution');
            // let that = this;
            // switch (e.source_type) {
            //     case 0:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 1:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 2:
            //         that.value=e.source_word;
            //         that.gotoSearch('paipin');
            //         break;
            //     case 3:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 4:
            //         that.value=e.source_word;
            //         that.gotoSearch('paiacution');
            //         break;
            //     case 6:
            //         that.value=e.source_word;
            //         that.gotoSearch('company');
            //         break;
            //     case 7:
            //         that.value=e.source_word;
            //         that.gotoSearch('market');
            //         break;
            //     case 5:
            //         that.value=e.source_word;
            //         that.gotoSearch('infor');
            //         break;
            // }
        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
        },
        // 取消
        cancel() {
            // this.$router.push({ path: "/" });
            let url = this.showWater ? "?from="+this.$route.query.from : "";
            scMdFunc('allClick', {
                cur_page: '35',
                cur_moudle: '35-1',
                cur_button: '35-1-2',
            })
            if (
                this.$route.query.searchType &&
                this.$route.query.searchType == "live"
            ) {
                window.location.href =
                    "https://m-auction.artron.net/live/" + url;
            } else {
                this.$router.push({ path: "/" + url });
            }
        },
        // 搜索功能
        async pnt() {
            if (!this.value) {
                this.hiss = true;
                this.param.page = 1;
                this.tionList = [];
                this.$router.push({
                    name: "paiacution",
                    query: {
                        searchValue: "",
                        from: this.showWater ? "cloud" : "",
                    },
                });
            }else{
                await searchWord({
                    keyword:this.value,
                    type:2
                }).then((res) => {
                        if (res.code == 0) {
                            this.wordList = res.data.list
                            this.wordList = this.wordList.map((item) => {
                                let replaceReg = new RegExp(this.value, 'g');
                                let replaceContent = '<span style="color:#18BD6F">' + this.value + '</span>';
                                if (item.source_word.includes(this.value)) {
                                item.source_wordShow = item.source_word.replace( replaceReg,replaceContent);
                                }else{
                                    item.source_wordShow = item.source_word
                                }
                                return item;
                            });
                        }
               })
            }
        },
        // 拍卖会跳转
        sessJump(item,) {
            console.log(item);
            scMdFunc('allClick', {
                cur_page: '14',
                cur_moudle: '14-4',
                cur_button: '14-4-'+(Number(index)+1),
            })
            this.$router.push({
                path: "/session/" + item.sessionCode,
                // params:{
                //     sessionCode: item.sessionCode,
                // },
                query: {
                    searchValue: "",
                    from: this.showWater ? this.$route.query.from : "",
                },
            });
        },
        zhuanjUMP(item,index) {
            scMdFunc('allClick', {
                cur_page: '14',
                cur_moudle: '14-5',
                cur_button: '14-5-'+(Number(index)+1),
            })
            this.$router.push({
                path: "/special/" + item.specialCode,
                query: {
                    searchValue: "",
                    from: this.showWater ? this.$route.query.from : "",
                },
            });
        },
        // 点击搜索时触发
        search() {
            console.log(this.value);
            this.param.page = 1;
            this.tionList = [];
            if (this.value) {
                this.getpmwill();
                // this.$router.push({
                //     name: "paiacution",
                //     query: {
                //         searchValue: encodeURIComponent(this.value),
                //         from: this.showWater ? this.$route.query.from : "",
                //     },
                // });
                this.hiss = false;
            } else {
                this.hiss = true;
            }
        },
        // tab切换
        gotoSearch(link) {
            console.log(link);
            // this.$router.push({
            //     name: link,
            //     query: { searchValue: encodeURIComponent(this.value) },
            // });
            if (
                this.$route.query.searchType &&
                this.$route.query.searchType == "live"
            ) {
                this.$router.push({
                    name: link,
                    query: {
                        searchValue: encodeURIComponent(this.value),
                        searchType: "live",
                        from: this.showWater ? this.$route.query.from : "",
                    },
                });
            } else {
                this.$router.push({
                    name: link,
                    query: {
                        searchValue: encodeURIComponent(this.value),
                        from: this.showWater ? this.$route.query.from : "",
                    },
                });
            }
            this.focusFlag=false;
            //   this.$refs.tabDom.children[index].classList.add("active").
        },
        getpmwill() {
            this.param.keyword = this.value;
            pmwill(this.param).then((res) => {
                if (res.code == 0) {
                    // 埋点
                    // this.metaTitle = res.data.meta.title;
                    if (!res.data.dataList && res.data.morePage != 1) {
                        this.loading = false;
                        this.finished = true;
                    }
                    if (res.data.dataList) {
                        this.tionList = this.tionList.concat(res.data.dataList);
                        this.loading = false;
                        this.param.page++;
                        if (res.data.morePage == 0) {
                            this.finished = true;
                           
                        }
                        if( this.tionList.length==0){
                             this.noMore = true;
                        }
                       
                    }
                    // setTimeout(function (){
                    //     var listSwiper = new Swiper('.swiper-container', {
                    //         slidesPerView: 'auto',
                    //         loop: false
                    //     });
                    // },200)
                }
            });
        },
        onLoad() {
            if (this.param.page >= 2) {
                this.getpmwill();
            }
        },
    },
    components: {
        histor,
        share,
        panel,
        DownLoadApp,
        watermark,
        EmptyPage
    },
};
</script>

<style scoped lang="scss">
// 搜索头部和tab页面
/deep/ .van-search__content {
    background-color: #f3f3f3;
    .van-icon-search::before{content:''}
    .van-field__left-icon .van-icon, .van-field__right-icon .van-icon{background:url("../../assets/img/icon_auc_search.png") no-repeat center;background-size: .7rem auto;width:.7rem;}
}
/deep/.van-search__action{padding:0 .4rem;font-size: .85rem;color:#969696;}
.search_back{
    width: 2rem;
    display: inline-block;
}
/deep/.van-search {
width: calc(100% - 2rem);
padding-left: 0;
}
.wordBox{
    position:absolute;
    top: 5rem;
    left: 0;
    background: #fff;
    width: 100%;
    z-index: 9;
    min-height: calc(100vh - 6rem);
    .sourceWord{
        width: calc(100% - 1.2rem);
        margin: 0.3rem 0.6rem;
        padding: 0.3rem 0;
        font-size: 0.8rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-bottom: 1px solid rgba(0,0,0,0.06);
        i{
            font-size: 1rem;
            vertical-align: middle;
            margin-right:0.2rem;
        }
    }
}
.tabItem:last-child {
    padding-right: 0.9rem;
}
.search_tabsmm::-webkit-scrollbar {
    display: none;
}
.search_tabsmm {
    display: flex;
    display: -webkit-box;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    padding: 0 0.75rem;
    width: 18.75rem;
    height: 1.8rem;
    position: relative;
    background-color: #fff;
    align-items: center;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
}
.search_tabsmm:after{display:block;height:.05rem;width:150%;position: absolute;bottom:.025rem;background-color: #DDDEE3;content:'';left:0;}

.search_tabsmm .tabItem {
    margin-right: 0.7rem;
    line-height: 1.8rem;
    height: 1.8rem;
}

.search_tabsmm .tabItem.active {
    color: #18bd6f;
    border-bottom: 0.15rem solid #18bd6f;
    position: relative;z-index: 1;
}
// 底部
/* 拍卖中 */
.auctionbox {
    width: 18.75rem;
}
.tab-top {
    width: 18.75rem;
    height: 2.4rem;
    background: #ffffff;
    padding: 0 0.75rem 0 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.05rem;
}
.tab-top .tabs {
    display: flex;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
}
.tab-top .tabs .tab {
    height: 2.4rem;
    margin-right: 1.5rem;
    line-height: 2.4rem;
}
.tabs .tab.active {
    color: #18bd6f;
    border-bottom: 0.15rem solid #18bd6f;
}
.tab-top .select-item {
    display: flex;
    align-items: center;
}
.select-item .col-line {
    width: 0.05rem;
    height: 0.8rem;
    box-shadow: -0.02rem 0rem 0rem 0rem #dddee3;
}
.select-item span {
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    margin-left: 0.75rem;
    margin-right: 0.15rem;
}
.select-item .select-icon {
    width: 0.65rem;
    height: 0.65rem;
    /* background: rgba(255, 255, 255, 0.01); */
    background-image: url(../../assets/img/screen.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
/* 拍卖中 */
.auction {
    width: 18.75rem;
}
.auction-item {
    /* padding: 0.75rem; */
    background-color: #fff;
    margin-bottom: 0.25rem;
}
.auction-item .item-top {
    display: flex;
    // align-items: center;
    padding: 0.75rem 0.75rem 0 0.75rem;
}
/* icon数字 5已结拍 4拍卖中 3待预展 2预展中 1待拍卖 */
.auction-item .item-icon5 {
    width: 1.9rem;
    height: 0.8rem;
    margin-top: 0.2rem;
    background-color: rgba(188, 189, 190, 0.20);
    background-image: url(../../assets/img/icon_list_tag_grey@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 80% 70%;
}
.auction-item .item-icon4 {
    width: 1.9rem;
    height: 0.8rem;
    margin-top: 0.2rem;
    background-color: rgba(235, 81, 100, 0.10);
    background-image: url(../../assets/img/icon_list_tag_red@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 80% 70%;
}
/* 这个待预展暂时没有图片 */
.auction-item .item-icon3 {
    width: 1.9rem;
    margin-top: 0.2rem;
    height: 0.7rem;
    background-image: url(../../assets/img/icon_list_tag_green2.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.auction-item .item-icon2 {
    width: 1.9rem;
    height: 0.8rem;
    margin-top: 0.2rem;
    background-color: rgba(54, 153, 114, 0.10);
    background-image: url(../../assets/img/icon_list_tag_green.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 80% 70%;
}
.auction-item .item-icon1 {
    width: 1.9rem;
    margin-top: 0.2rem;
    height: 0.7rem;
    background-image: url(../../assets/img/icon_list_tag_green@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.auction-item .txt {
    width: 15.25rem;
    height: 1.1rem;
    font-size: 0.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    line-height: 1.1rem;
    margin-left: 0.1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
}
.auction-item .txt span {
    color: #18bd6f;
}
.auction-item .item-brief {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 0.5rem;
    padding: 0 0.75rem 0 0.75rem;
}
.item-brief .brief {
    display: flex;
    align-items: center;
    line-height: .9rem;
    margin-bottom: .15rem;
}
.item-brief .brief:last-child{margin-bottom: 0;}
.item-brief .brief span {
    /* width: 7.8rem; */
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    line-height: 0.9rem;
}
.item-brief .brief i{
    font-size: .65rem;color: #969696;margin-left: .5rem;line-height: .9rem;
}
.item-brief .brief-icon {
    width: 0.65rem;
    height: 0.65rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.3rem;
}
.item-brief .brief-icon img {
    width: 100%;
    height: 100%;
}

.speSwiper {
    background: #ffffff;
    padding: .6rem 0.75rem .75rem;
}
.speSwiper .swiper-slide {
    width: 4.75rem;
    margin-right: 0.4rem;
}
.speSwiper .swiper-slide .imgCenter {
    height: 6.25rem;
    background: #d8d8d8;
    border-radius: 0.2rem;
    overflow: hidden;
    position: relative;
}
.speSwiper .swiper-slide .imgCenter img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.speSwiper .swiper-slide .imgCenter .live {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.1rem;
    background: #1bbd6f;
}
.speSwiper .swiper-slide .imgCenter .liveReview {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.1rem;
    background: rgba(0, 0, 0, 0.85);
    font-size: 0.65rem;
    line-height: 1.1rem;
    color: #ffffff;
    text-align: center;
}
.speSwiper .swiper-slide .imgCenter .HiPic {
    background: url(../../assets/img/icon_list_HDpic_26@2x.png) no-repeat;
    position: absolute;
    top: 0;
    right: 0;
    width: 1.7rem;
    height: 0.8rem;
    background-size: 100% 100%;
}
.speSwiper .swiper-slide .name {
    margin-top: 0.4rem;
    font-size: 0.65rem;
    line-height: 0.9rem;
    color: #969696;
    height: 1.8rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.speSwiper .swiper-slide .tags {
    margin-top: 0.3rem;
    font-size: 0;
}
.speSwiper .swiper-slide .tag {
    display: inline-block;
    height: 0.8rem;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 0.3rem;
}
.speSwiper .swiper-slide .tag:last-child {
    margin-right: 0;
}
.speSwiper .swiper-slide .videoLive {
    width: 2.4rem;
    background-image: url(../../assets/img/icon_video_live.png);
}
.speSwiper .swiper-slide .imgLive {
    width: 2.4rem;
    background-image: url(../../assets/img/icon_img_live.png);
}
.speSwiper .swiper-slide .tbPai {
    width: 1.9rem;
    background-image: url(../../assets/img/icon_tbpai.png);
}
.speSwiper .swiper-slide .xsPai {
    border: 1px solid #eee;
    color: #999;
    font-size: 0.45rem;
    padding: 0.05rem 0.15rem;
    height: auto;
   
}
/* 底线 */
.footer {
    width: 18.75rem;
    height: 4rem;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.footer .footer-content {
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #cccccc;
}
.footer .footer-left,
.footer .footer-right {
    width: 2.5rem;
    height: 0.05rem;
    background: #dddee3;
    margin: 0 0.5rem;
}
.speSwiperContainer{width:100%;overflow-x: auto;overflow-y: hidden;
    .speSwiperWrapper{
        display:flex;
    }
}
.speSwiperContainer::-webkit-scrollbar{display:none;}
</style>